import React from 'react';
import styled, { css } from 'styled-components/macro';
import pluralize from 'helpers/pluralize';

import Anchor from 'components/base/Anchor/Anchor';
import NoData from 'components/styled/NoData/NoData';
import ActiveFilters from 'components/base/ActiveFilters/ActiveFilters';

export const TablePlaceholder = styled('div')`
  margin-top: 1em;
  position: relative;
  min-height: 10em;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIyOTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI0Q0RDhERCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCAwaDF2MUgwek0wIDczaDF2MUgwek0wIDE0NmgxdjFIMHpNMCAyMTloMXYxSDB6TTAgMjkwaDF2MUgweiIvPjwvZz48L3N2Zz4=);
  background-size: 100% 100%;
`;

export const NoDataOverlay = styled.div<{
  isSmallScreen: boolean;
  marginTop?: string;
}>`
  ${({ isSmallScreen, marginTop }): any =>
    !isSmallScreen &&
    css`
      position: absolute;
      left: 0;
      top: ${marginTop ? marginTop : '0'};
      width: 100%;
      height: ${marginTop ? `calc(100% - ${marginTop})` : '100%'};
    `};

  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Text = styled('div')`
  margin-top: 1em;
  margin-bottom: 1em;
`;

const StyledActiveFilters = styled(ActiveFilters)`
  display: inline;
`;

const allowedFiltersPerType: any = {
  track: ['streaming'],
  release: ['download'],
  artist: ['streaming'],
  project: ['streaming'],
  label: [],
  playlist: ['streaming', 'customRegion', 'country', 'region'],
  concert: ['region', 'country'],
};

interface IPlaceholderProps {
  /** The current Entity Type */
  entityType?: string;
  /** The type we are showing in the table */
  type: string;
  /** Is this a small screen? Used to the table and make the message static */
  isSmallScreen?: boolean;
  isTopList?: boolean;
  marginTop?: string;
}

/** Placeholder overlay for the Table. This overlays the table when there are no items in the table. */
const Placeholder: React.FC<IPlaceholderProps> = ({
  entityType,
  type,
  isSmallScreen = false,
  isTopList = false,
  marginTop,
}) => {
  return (
    <>
      {!isSmallScreen && <TablePlaceholder />}
      <NoDataOverlay isSmallScreen={isSmallScreen} marginTop={marginTop}>
        <NoData isSmallScreen={isSmallScreen}>
          <h3>No {pluralize(type)} available</h3>
          {entityType && (
            <Text>
              Unfortunately, there are no {pluralize(type)}{' '}
              {entityType || isTopList
                ? `associated with this ${isTopList ? 'selection' : entityType}`
                : 'found'}
              <StyledActiveFilters
                label=" for "
                allowedFilters={allowedFiltersPerType[type]}
              />
              If there should be, please contact{' '}
              <Anchor to="/glossary/general-information/contact">
                Opus support
              </Anchor>
              .
            </Text>
          )}
        </NoData>
      </NoDataOverlay>
    </>
  );
};

/** @component */
export default Placeholder;
